import { baseApi } from "../../api/baseApi";
import { TResponseRedux } from "@/types/types";
export type TQueryParam = {
  name: string;
  value: boolean | React.Key;
};
const orderApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getClientOrders: builder.query({
      query: (args) => {
        const params = new URLSearchParams();
        if (args) {
          args.forEach((element: TQueryParam) => {
            params.append(element.name, element.value as string);
          });
        }
        return {
          url: "/order/get-client-orders",
          method: "GET",
          params: params,
        };
      },
      providesTags:['Order']
    }),
    getClientDraftOrders: builder.query({
      query: (args) => {
        const params = new URLSearchParams();
        if (args) {
          args.forEach((element: TQueryParam) => {
            params.append(element.name, element.value as string);
          });
        }
        return {
          url: "/order/get-draft-orders",
          method: "GET",
          params: params,
        };
      },
      providesTags:['Order']
    }),

    getOrderDetails: builder.query({
      query: (id) => ({
        url: `/order/get-order-details/${id}`,
        method: "GET",
      }),
      providesTags:['OrderDetails']
    }),

    initOrder: builder.mutation({
      query: (payload) => ({
        url: "/order/init-order",
        method: "POST",
        body: payload,
      }),
    }),
    placeOrder: builder.mutation({
      query: (payload) => ({
        url: "/order/place-order",
        method: "PUT",
        body: payload,
      }),
      invalidatesTags:['Order','User']
    }),
    saveDraft: builder.mutation({
      query: (payload) => ({
        url: "/order/save-draft",
        method: "POST",
        body: payload,
      }),
      invalidatesTags:['Order',]
    }),

    createOrderPaymentInstance: builder.mutation({
      query: payload => ({
        url: "/order/create-payment-instance",
        method: "POST",
        body: payload,
      }),
    }),
    verifyOrderPayment: builder.mutation({
      query: payload => ({
        url: "/order/verify-payment",
        method: "POST",
        body: payload,
      }),
      invalidatesTags:['User','Order']
    }),
  }),
});

export const {
  useInitOrderMutation,
  usePlaceOrderMutation,
  useGetClientOrdersQuery,
  useGetOrderDetailsQuery,
  useCreateOrderPaymentInstanceMutation,
  useVerifyOrderPaymentMutation,
  useSaveDraftMutation,
  useGetClientDraftOrdersQuery
} = orderApi;
